import { connectHook } from 'app/common/components/connect-hook';
import { ProjectToolbar } from './project-toolbar';
import { useProjectToolbar } from './project-toolbar-hook';

export default connectHook(ProjectToolbar, useProjectToolbar);
